import ActiveSearchQuery from "./ActiveSearchQuery.gql";
import { graphql } from "react-apollo";

export default (propName, featureSlug) =>
  graphql(ActiveSearchQuery, {
    name: propName,
    options: {
      variables: { feature: featureSlug },
    },
  });
